import { MS_PER_DAY } from '../../../models/constants';

const DAYS_PRIOR_MIN = 1;
const DAYS_PRIOR_MAX = 30;

export class DateRange {
  readonly endDate: Date;
  readonly daysPrior: number;
  readonly startDate: Date;

  constructor(endDate: Date, daysPrior: number);
  constructor(endDate: Date, startDate: Date);
  constructor(endDate: Date, start: Date | number) {
    const today = this.createEndOfDay(new Date());

    this.endDate = endDate > today ? today : this.createEndOfDay(endDate);

    this.daysPrior =
      typeof start === 'number'
        ? this.boundDaysPrior(start)
        : this.calculateDaysPrior(this.endDate, this.createBeginOfDay(start));

    this.startDate = this.createBeginOfDay(
      new Date(this.endDate.getTime() - this.daysPrior * MS_PER_DAY)
    );
  }

  private createBeginOfDay(date: Date) {
    return new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      0,
      0,
      0,
      0
    );
  }

  private createEndOfDay(date: Date) {
    return new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      23,
      59,
      59,
      0
    );
  }

  private boundDaysPrior(value: number) {
    return Math.max(
      Math.min(Math.floor(value), DAYS_PRIOR_MAX),
      DAYS_PRIOR_MIN
    );
  }

  private calculateDaysPrior(endDate: Date, startDate: Date) {
    if (startDate > endDate) {
      throw new RangeError('startDate cannot be greater than endDate.');
    }

    const delta = endDate.getTime() - startDate.getTime();
    return this.boundDaysPrior(delta / MS_PER_DAY);
  }
}
